import { actionTypes } from '../actions/types';
import { InterestsAndFeesWeb, RepaymentPeriodTermsWeb } from '../generated-types';

type AppActions = import('../actions/types').AppActions;

export interface ProductsReducer {
    products: {
        interestsAndFees: InterestsAndFeesWeb[] | null;
        repaymentPeriodTerms: RepaymentPeriodTermsWeb | null;
    } | null;
    selectedProduct: any;
}

export const initialState: ProductsReducer = {
    products: {
        interestsAndFees: null,
        repaymentPeriodTerms: null,
    },
    selectedProduct: {},
};

export const productsReducer = (state = initialState, action: AppActions = {} as AppActions): ProductsReducer => {
    switch (action.type) {
        case actionTypes.FETCH_PRODUCTS_FULFILLED: {
            return {
                ...state,
                products: {
                    ...state.products,
                    ...action.payload,
                },
            };
        }

        default:
            return state;
    }
};
